const currentQueries = (router) => {
  const [basePath, query] = router.asPath.split("?");
  const cleanedQuery = query ? decodeURI(query) : undefined;
  const queries = cleanedQuery?.split("&").reduce((acc, curr) => {
    const [key, value] = curr.split("=");
    return [
      ...acc,
      {
        key,
        value,
      },
    ];
  }, []);

  return {
    basePath,
    query: cleanedQuery,
    queries,
  };
};

export const getPaginationFromUri = (route) => {
  // const currentQ = utils.currentQueries(route);
  const currentQ = currentQueries(route);
  const findedPageQuery = currentQ.queries?.find((q) => q.key === "page");
  return findedPageQuery ? Number(findedPageQuery.value) : 1;
};

export const mergeQueryString = (queries) => {
  return queries?.reduce((acc, curr, index) => {
    const { key, value } = curr;
    return index === 0
      ? acc.concat(`${key}=${value}`)
      : acc.concat(`&${key}=${value}`);
  }, "");
};

export const removeQueryString = (router, keyToRemove) => {
  const currentQ = currentQueries(router);
  let newRoute = `${currentQ.basePath}?`;
  let updated = currentQ.queries?.filter((q) => q.key !== keyToRemove);
  updated = updated.filter((q) => q.key !== "page");
  if (keyToRemove === "range-year") {
    const removeK = ["lte-year", "gte-year"];
    updated = updated.filter((q) => !removeK.includes(q.key));
  }
  if (keyToRemove === "range-price") {
    const removeK = ["lte-price", "gte-price"];
    updated = updated.filter((q) => !removeK.includes(q.key));
  }
  const queryString = mergeQueryString(updated);
  newRoute = newRoute + queryString;
  //router.push(newRoute, undefined, { shallow: true });
  return newRoute;
};

export const manageQueries = (router, queriesChanges, keysToRemove) => {
  const currentQ = currentQueries(router);

  let newRoute = `${currentQ.basePath}?`;
  let toUpdate = [];
  let toStore = [];

  if (currentQ.queries) {
    let cleanedQueries = currentQ.queries;
    if (keysToRemove) {
      cleanedQueries = currentQ.queries.filter(
        (q) => !keysToRemove.includes(q.key)
      );
    }

    toUpdate = cleanedQueries.map((q) => {
      const finded = queriesChanges.find((qq) => qq.key === q.key);
      return finded ? { key: q.key, value: finded.value } : q;
    });

    toStore = queriesChanges.filter(
      (q) => !cleanedQueries?.find((qq) => qq.key === q.key)
    );
  } else {
    toStore = queriesChanges;
  }
  const newQueries = [...toUpdate, ...toStore];
  const queryString = mergeQueryString(newQueries);
  return newRoute + queryString;
  // router.push(newRoute + queryString, undefined, { shallow: true });
};

export const getFiltersFromUri = (route, filterKeys) => {
  const currentQ = currentQueries(route);
  // const filtersKeys = ["brand", "type", "transmission", "year"];
  const filters = currentQ.queries?.filter((q) => filterKeys.includes(q.key));
  return filters;
};

export const encodeSearchQueryForGoogleMaps = (address) => {
  let searchQuery = address.replaceAll(" ", "+");
  searchQuery = searchQuery.replaceAll("#", "%23");
  return searchQuery;
};

const api = {
  getPaginationFromUri,
  mergeQueryString,
  removeQueryString,
  getFiltersFromUri,
  manageQueries,
  encodeSearchQueryForGoogleMaps,
};

export default api;
